// InvitaAmici.tsx — v038: nell'attesa del torneo o della partita a 4, gli amici da invitare con un tocco (gli arriva
// una notifica con il link). Solo per chi ha l'account e almeno un amico.
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "./Avatar.tsx";
import { leggiAmici, type Amico } from "../servizi/amici.ts";
import { richiesta } from "../servizi/api.ts";
import { useAccount } from "../servizi/account.ts";
import { leggiImpostazione, eBooleano } from "../servizi/impostazioni.ts";
import { IMP_APP } from "../costanti.ts";
import { vibra } from "../servizi/nativo.ts";

export function InvitaAmici({ tipo, codice }: { tipo: "torneo" | "gruppo"; codice: string }) {
  const { t } = useTranslation();
  const account = useAccount();
  const registrato = account.tipo === "registrato";
  const [amici, setAmici] = useState<Amico[] | null>(null);
  const [invitati, setInvitati] = useState<ReadonlySet<number>>(new Set());
  useEffect(() => {
    if (!registrato || !leggiImpostazione(IMP_APP.pushAttive, true, eBooleano)) return;
    void leggiAmici()
      .then((e) => setAmici(e.amici))
      .catch(() => setAmici([]));
  }, [registrato]);
  if (!amici?.length) return null;
  const invita = (a: Amico) => {
    vibra("leggero");
    setInvitati((s) => new Set(s).add(a.id));
    void richiesta(`/api/v1/amici/${a.id}/invita`, { metodo: "POST", corpo: { tipo, codice } }).catch(() =>
      setInvitati((s) => {
        const n = new Set(s);
        n.delete(a.id);
        return n;
      }),
    );
  };
  return (
    <section className="ld-invita-amici" aria-label={t("amici.invita_titolo")}>
      <h3 className="scheda-titolo">{t("amici.invita_titolo")}</h3>
      <ul className="ld-invita-elenco">
        {amici.slice(0, 30).map((a) => (
          <li key={a.id} className="ld-invita-riga">
            <Avatar quale={a.avatar ?? "mistero"} dimensione={40} />
            <span className="ld-invita-nome">{a.nome}</span>
            <button type="button" className="pulsante pulsante-piccolo" disabled={invitati.has(a.id)} aria-label={t("amici.invita_nome", { nome: a.nome })} onClick={() => invita(a)}>
              {invitati.has(a.id) ? t("amici.invitato") : t("amici.invita")}
            </button>
          </li>
        ))}
      </ul>
      <p className="nota">{t("amici.invita_nota")}</p>
    </section>
  );
}
